var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.activities.length > 0)?_c('ScheduleCalendar',{attrs:{"activities":_vm.activities,"phone":_vm.phone,"edit":_vm.edit},on:{"deleteAct":function($event){return _vm.deleteAct($event)},"editActivity":function($event){return _vm.editActivity($event)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }